import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CargoVanIcon = createIcon({
  displayName: 'CargoVanIcon',
  viewBox: '0 0 40 24',
  path: /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 19.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM28 20H13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20l-5-1V1h28l4.774 10m0 0L39 13v6.5l-4 .5m-1.226-9H25V5h5.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "31.5",
    cy: "19.5",
    r: "3.5"
  }))
});
//# sourceMappingURL=CargoVan.js.map